module.exports = __webpack_public_path__ + "img/rs.30a43dc0.svg";